import dynamic from 'next/dynamic';
import type { Carousel as CarouselType } from 'react-responsive-carousel';

const MainContainer = dynamic(() => import('./MainContainer'));
const MultiCarousel = dynamic(() => import('src/shared/MultiCarousel/MultiCarousel'));
const Carousel: typeof CarouselType = dynamic(() => import('react-responsive-carousel').then((mod) => mod.Carousel)) as any;

export { MainContainer, MultiCarousel, Carousel };
